import "./social-icon.scss";
import React from "react";

const SocialIcon = ({ icon, label, link }) => {
   return (
      <a
         href={link}
         target="_blank"
         rel="noreferrer nofollow"
         className="social-icon"
      >
         <img src={icon} alt="Ikona" className="social-icon__icon" />
         {label && <div className="social-icon__text">{label}</div>}
      </a>
   );
};

export default SocialIcon;
